<template>
  <section class="section pt-5">
    <team-datatable />
  </section>
</template>

<script>
import TeamDatatable from "./team_datatable/Index.vue";

export default {
  name: "TeamIndex",
  components: { TeamDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
